import React, { Component } from "react";
import PropTypes from "prop-types";
import axios from "axios";
import ReactDataGrid from "react-data-grid";
import ConfirmActionModal from "../Common/confirmActionModal";
import ResetEmailModal from "./ResetEmailModal";
import ChoosePaymentMethodModal from "../../containers/Settings/ChoosePaymentMethodModal";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import { SkyLightStateless } from "react-skylight";
import {
  ButtonToolbar,
  MenuItem,
  DropdownButton,
  Button,
  Input,
  Row,
  Col,
} from "react-bootstrap";
import {
  RESET_PASSWORD_URL,
  CHANGE_STRIPE_URL,
  USERNAME_URL,
} from "../../actions/url";
import { ROOT_URL, ROOT_API_URL, isHMM} from "../../actions/root_url";
import userManagementModals from "../../components/Common/modals/userManagement";

const { DispatcherBindModal } = userManagementModals;
const isEcity =
  ROOT_API_URL === "https://ct-scm.truckxi.com/api/" ||
  ROOT_API_URL === "https://ctstage-scm.truckxi.com/api/";
const isABC =
  ROOT_API_URL === "https://abc-scm.truckxi.com/api/" ||
  ROOT_URL === "https://abc-scm.truckxi.com/api/";

const styles = {
  buttonBar: {
    // position: 'absolute',
    marginLeft: "235px",
    marginBottom: "5px",
    zIndex: 2,
  },
  buttonStyle: {
    position: "absolute",
  },
  createDialogStyle: {
    width: "550px",
    height: "300px",
    marginLeft: "-15%",
  },
  DispatcherBindModalStyle: {
    width: "550px",
    height: "200px",
    marginLeft: "-15%",
  },
};

class MobileUserTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rows: props.rows,
      filters: {},
      sortColumn: null,
      sortDirection: null,
      showPasswordPopup: false,
      showEmailPopup: false,
      showChoosePaymentMethod: false,
      selectedUserId: "",
      selectedMobileUserId: "",
      selectedCustomerId: "",
      isStripe: "",
      dispatcherBindModalVisibility: false,
    };
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.closeResetPasswordPopup = this.closeResetPasswordPopup.bind(this);
    this.openResetPasswordPopup = this.openResetPasswordPopup.bind(this);
    this.closeResetEmailPopup = this.closeResetEmailPopup.bind(this);
    this.openResetEmailPopup = this.openResetEmailPopup.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      this.setState({ rows: nextProps.rows });
    }
    if (
      nextProps.checkPasswordSuccess &&
      nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess
    ) {
      this.closeResetPasswordPopup();
      this.resetPassword();
    }
  }

  // MODAL ACTIONS
  setDispatcherBindModalVisibility = (dispatcherBindModalVisibility = false) =>
    this.setState({ dispatcherBindModalVisibility });

  getRows = () => Data.Selectors.getRows(this.state);

  getSize = () => this.getRows().length;

  // Handle the row select function
  onRowsSelected = (rows) => {
    this.props.clearUsernameData();
    const newRows = this.getRows();
    newRows.map((r) => {
      r.isSelected = false;
    });
    rows.map((r) => {
      newRows[r.rowIdx].isSelected = true;
    });
    this.setState(
      {
        selectedUserId: rows[0].row.User_id,
        selectedMobileUserId: rows[0].row.MobileUser_id,
        selectedCustomerId: rows[0].row.Customer_id_id,
        isStripe: rows[0].row.IsStripe,
      },
      () => {
        this.props.grabMobileUserID(this.state.selectedMobileUserId);
        this.props.setDefaultOfForm(
          "IsStripe",
          this.state.isStripe,
          "choosePaymentMethod"
        );
      }
    );
  };

  onRowsDeselected = (rows) => {
    const newRows = this.getRows();
    rows.map((r) => {
      newRows[r.rowIdx].isSelected = false;
    });
    this.setState(
      {
        selectedUserId: "",
        selectedMobileUserId: "",
        selectedCustomerId: "",
        isStripe: "",
      },
      () => {
        this.props.clearUsernameData();
        this.props.setDefaultOfForm("IsStripe", null, "choosePaymentMethod");
      }
    );
  };

  resetPassword = () => {
    const letter = Math.random()
      .toString(36)
      .replace(/[^a-z]+/g, "")
      .substr(0, 4);
    const password = `${letter}1234`;
    const url = RESET_PASSWORD_URL + this.state.selectedUserId;

    axios
      .put(
        url,
        {
          password,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          alert(`Reset password to: ${password}`);
        }
      })
      .catch((error) => {
        alert("Could not reset password, please try again!");
      });
    this.setState({
      showPasswordPopup: false,
    });
  };

  savePaymentMethod = (IsStripe) => {
    const customer_id = this.state.selectedCustomerId;
    const url = CHANGE_STRIPE_URL + customer_id;
    axios
      .put(
        url,
        {
          IsStripe,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          alert(`Payment Method Changed Successfully`);
        }
      })
      .catch((err) => {
        alert("Payment Method Change Fail");
      });
    this.setState(
      {
        showChoosePaymentMethod: false,
        selectedUserId: "",
        selectedMobileUserId: "",
        selectedCustomerId: "",
        isStripe: "",
      },
      () => {
        this.props.fetchMobileUsers(
          this.props.currentPage,
          this.props.limit,
          this.props.searchCustomerNo,
          this.props.searchFirstName,
          this.props.searchLastName,
          this.props.searchEmail
        );
      }
    );
  };

  rowGetter = (rowIdx) => {
    const rows = this.getRows();
    return rows[rowIdx];
  };

  // Handle the sortable function

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({ sortColumn, sortDirection });
  };

  handleFilterChange = (filter) => {
    const newFilters = Object.assign({}, this.state.filters);
    if (filter.filterTerm) {
      newFilters[filter.column.key] = filter;
    } else {
      delete newFilters[filter.column.key];
    }
    this.setState({ filters: newFilters });
  };

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openResetPasswordPopup() {
    this.setState({
      showPasswordPopup: true,
    });
    this.props.clearCheckPassword();
  }

  closeResetPasswordPopup() {
    this.setState({
      showPasswordPopup: false,
    });
  }

  openResetEmailPopup() {
    this.setState({
      showEmailPopup: true,
    });
  }

  closeResetEmailPopup() {
    this.setState({
      showEmailPopup: false,
    });
  }

  openChoosePaymentMethod = () => {
    this.setState({
      showChoosePaymentMethod: true,
    });
  };

  closeChoosePaymentMethod = () => {
    this.setState({
      showChoosePaymentMethod: false,
    });
  };

  onSelectShowPrice = (show) => {
    const url = USERNAME_URL + this.state.selectedMobileUserId + "/";
    axios
      .put(
        url,
        {
          IsWebShowPrice: show,
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          this.props.handleShowPriceChange();
          // alert(`Changed Show Price to ${show}`);
        }
      })
      .catch((error) => {
        alert("Could not set Show Price, please try again!");
      });
  };

  handleDispatcherBindSuccess = () => {
    this.props.refetchMobileUsers();
  };

  render() {
    const columns = [
      {
        key: "CustomerNum",
        name: <Translate value="customer_no" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: "FirstName",
        name: <Translate value="first_name" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: "LastName",
        name: <Translate value="last_name" />,
        resizable: true,
        width: 90,
        sortable: true,
        filterable: true,
      },
      {
        key: "email",
        name: <Translate value="email" />,
        resizable: true,
        width: 200,
        sortable: true,
        filterable: true,
      },
      {
        key: "phone",
        name: <Translate value="phone" />,
        resizable: true,
        width: 150,
        sortable: true,
        filterable: true,
      },
      ...(isABC
        ? [
            {
              key: "DispatcherName",
              name: <Translate value="dispatch_name" />,
              resizable: true,
              width: 150,
              sortable: true,
              filterable: true,
            },
          ]
        : []),
    ];

    if (isHMM) {
      const indexPhone = _.findIndex(columns, { key: "phone" });
      const showPriceColumn = {
        key: "IsWebShowPriceDisplay",
        name: <Translate value="show_price" />,
        resizable: true,
        sortable: true,
        width: 80,
        filterable: true,
        formatter: ({ value }) => (
          <div style={{ width: "100%", height: "100%", textAlign: "center" }}>
            {value}
          </div>
        ),
      };
      columns.splice(indexPhone, 0, showPriceColumn);
      if (this.state.rows.length > 0) {
        this.state.rows.map((row) => {
          if (row.IsWebShowPrice === true) {
            row.IsWebShowPriceDisplay = "yes";
          } else {
            row.IsWebShowPriceDisplay = "no";
          }
        });
      }
    }
    const resetEmail = <Translate value="reset_email" />;
    const resetPassword = <Translate value="reset_password" />;
    const changePaymentMethod = <Translate value="change_payment_method" />;
    return (
      <div>
        <ButtonToolbar style={styles.buttonBar}>
          <DropdownButton
            bsStyle="warning"
            disabled={this.state.selectedUserId === ""}
            title={
              <span>
                <i className="fa fa-pencil" />
                <Translate value="edit" />
              </span>
            }
          >
            <MenuItem onClick={this.openResetPasswordPopup}>
              <Translate value="reset password" />
            </MenuItem>
            <MenuItem onClick={this.openResetEmailPopup}>
              <Translate value="reset email" />
            </MenuItem>
            {isEcity && (
              <MenuItem onClick={this.openChoosePaymentMethod}>
                <Translate value="change_payment_method" />
              </MenuItem>
            )}
          </DropdownButton>
          <Button
            bsStyle="success"
            onClick={() => this.props.fetchUsername(this.props.mobileUserId)}
          >
            <em className="fa fa-download" />
            <Translate value="fetch_username" />
          </Button>
          {isHMM && (
            <DropdownButton
              bsStyle="warning"
              disabled={this.state.selectedUserId === ""}
              title={
                <span>
                  <Translate value="show_price" />
                </span>
              }
            >
              <MenuItem onClick={() => this.onSelectShowPrice(true)}>
                <Translate value="show" />
              </MenuItem>
              <MenuItem onClick={() => this.onSelectShowPrice(false)}>
                <Translate value="hide" />
              </MenuItem>
            </DropdownButton>
          )}
          {isABC && (
            <Button
              bsStyle="success"
              onClick={() => this.setDispatcherBindModalVisibility(true)}
              disabled={this.state.selectedUserId === ""}
            >
              <em className="fa fa-link" />
              <Translate value="dispatcher_bind" />
            </Button>
          )}
        </ButtonToolbar>
        <SkyLightStateless
          dialogStyles={styles.createDialogStyle}
          isVisible={this.state.showPasswordPopup}
          onCloseClicked={this.closeResetPasswordPopup}
          title={resetPassword}
        >
          <ConfirmActionModal
            case="confirmPassword"
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={styles.createDialogStyle}
          isVisible={this.state.showEmailPopup}
          onCloseClicked={this.closeResetEmailPopup.bind(this)}
          title={resetEmail}
        >
          <ResetEmailModal
            isVisible={this.state.showEmailPopup}
            onCloseClicked={this.closeResetEmailPopup}
            selectedUserId={this.state.selectedUserId}
          />
        </SkyLightStateless>
        <SkyLightStateless
          dialogStyles={styles.createDialogStyle}
          isVisible={this.state.showChoosePaymentMethod}
          onCloseClicked={this.closeChoosePaymentMethod}
          title={changePaymentMethod}
        >
          <ChoosePaymentMethodModal
            case="confirmPaymentMethod"
            isStripe={this.state.isStripe}
            id={this.state.selectedCustomerId}
            changePaymentMethod={this.savePaymentMethod}
          />
        </SkyLightStateless>
        <div
          id="MobileUserTable-dataGrid1"
          style={{ marginTop: "55px", zIndex: 0 }}
        >
          <ReactDataGrid
            rowKey="MobileUser_id"
            onGridSort={this.handleGridSort}
            // toolbar={<Toolbar enableFilter />}
            headerRowHeight={50}
            rowHeight={25}
            onAddFilter={this.handleFilterChange}
            columns={columns}
            minHeight={580}
            rowGetter={this.rowGetter}
            rowsCount={this.getSize()}
            enableRowSelect="single"
            rowSelection={{
              showCheckbox: true,
              enableShiftSelect: true,
              onRowsSelected: this.onRowsSelected,
              onRowsDeselected: this.onRowsDeselected,
              selectBy: {
                isSelectedKey: "isSelected",
              },
            }}
          />
        </div>
        <SkyLightStateless
          dialogStyles={styles.createDialogStyle}
          isVisible={this.state.dispatcherBindModalVisibility}
          onCloseClicked={this.setDispatcherBindModalVisibility}
          title={"Bind Mobile user with scm user"}
        >
          <DispatcherBindModal
            scmUsers={this.props.scmUsers || []}
            selectedMobileUserId={this.state.selectedMobileUserId}
            handleDispatcherBindSuccess={this.handleDispatcherBindSuccess}
          />
        </SkyLightStateless>
      </div>
    );
  }
}

MobileUserTable.propTypes = {
  clearCheckPassword: PropTypes.func.isRequired,
  checkPassword: PropTypes.func.isRequired,
  checkPasswordSuccess: PropTypes.bool.isRequired,
  checkPasswordFailure: PropTypes.bool.isRequired,
};

export default MobileUserTable;



// WEBPACK FOOTER //
// ./master/jsx/components/Settings/MobileUserTable.jsx